import React from "react";
import { Box, Modal, ModalProps } from "@mui/material";

function Backdrop(props: ModalProps) {
  return (
    <Modal {...props} open={props.open}>
      <Box
        sx={{
          position: "absolute",
          top: "0",
          width: "100vw",
          height: "100%",
          bgcolor: "rgba(233,213,222,0.21)",
          overflow: "none",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 3,
        }}
      >
        {props.children}
      </Box>
    </Modal>
  );
}

export default Backdrop;
